export default __webpack_public_path__ + "static/frame-2231-2b19d67afa251a14cb83a3f77c9803c6.png";